import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {action, makeObservable} from 'mobx';
import {inject, observer} from 'mobx-react';
import get from 'lodash/get';
import find from 'lodash/find';
import {styleable} from 'decorators';
import {injectIntl} from 'react-intl';
import {StepNumberDesktop as StepNumber} from 'components/StepNumber';
import ReportIssueButton from '../../StepCheckToolbar/Escalation/Button';
import DispatchButton from '../../StepCheckToolbar/Dispatch/Button';

import {getChecklistFromLocalStorage} from 'utils/checklist-utils';

import Toolbar from './Toolbar';

import {Left, Right, StepCard, StepContent, StepMedia, StepSlide} from './styles';

@inject('store')
@observer
@styleable
class StepCardComponent extends Component {
  static defaultProps = {
    isCheck: true,
    shouldShowSpinnerWhileLoading: false,
    step: Object.freeze({}),
    noteContentKey: 'contentHtml'
  };

  static propTypes = {
    autoplayVideo: PropTypes.bool,
    content: PropTypes.element,
    getToolbarButtonStyle: PropTypes.func,
    hintContent: PropTypes.element,
    hintImageSizes: PropTypes.string,
    imageSizes: PropTypes.string,
    isCheck: PropTypes.bool,
    media: PropTypes.element,
    number: PropTypes.number,
    onToggleHint: PropTypes.func,
    orientation: PropTypes.oneOf(['landscape', 'portrait']).isRequired,
    selectedHintType: PropTypes.string,
    shouldAllToolbarItemsBeEnabled: PropTypes.bool,
    shouldShowSpinnerWhileLoading: PropTypes.bool,
    step: PropTypes.object,
    noteContentKey: PropTypes.oneOf(['content', 'contentHtml']).isRequired,
    checklistTemplate: PropTypes.object
  };

  constructor(props) {
    super(props);
    makeObservable(this);
  }

  componentDidMount = () => {
    const {isCheck, isCurrent, isCMS} = this.props;

    if (isCheck && !isCMS) {
      const {
        store: {
          instructionPage: {
            currentInstruction: {id: instructionId}
          },
          checklist: {setChecklist}
        }
      } = this.props;

      const checklist = getChecklistFromLocalStorage(instructionId);
      setChecklist(checklist);
    } else {
      isCurrent && this.popupMandatoryNote();
    }
  };

  componentDidUpdate = prevProps => {
    if (!prevProps.isCurrent && this.props.isCurrent) {
      this.popupMandatoryNote();
    }
  };

  @action
  popupMandatoryNote = () => {
    const mandatoryNoteId = get(find(this.props.step.notes, {mandatory: true}), 'iconId');
    mandatoryNoteId && this.props.onToggleHint({type: mandatoryNoteId});
  };

  render() {
    const {
      autoplayVideo,
      content,
      getToolbarButtonStyle,
      hintContent,
      hintImageSizes,
      imageSizes,
      isCheck,
      media,
      onToggleHint,
      orientation,
      selectedHintType,
      shouldAllToolbarItemsBeEnabled,
      shouldShowSpinnerWhileLoading,
      step,
      number = step.number || step.position + 1,
      noteContentKey,
      isCMS,
      store,
      stepIndex,
      footer
    } = this.props;

    const {
      platform: {
        hasChecklistEscalation,
        hasDispatchSite,
        hasDispatchEnabled,
        developmentFeatureFlags: {dispatch}
      },
      instructionPage
    } = store;

    const {imageUrl, instructionHtml, notes} = step;
    const hasAlertRecipients = instructionPage?.currentInstruction?.hasAlertRecipients;
    const metadata = step.metadata ? step.metadata : step.media?.metadata ? step.media.metadata : {};
    const hasDispatchButton = dispatch && hasDispatchSite && hasDispatchEnabled && isCheck && !isCMS;
    const hasReportButton = !hasDispatchButton && (hasChecklistEscalation || hasAlertRecipients) && isCheck && !isCMS;

    return (
      <StepSlide data-cy="step-card" hasReportButton={hasReportButton}>
        {hasReportButton && <ReportIssueButton stepIndex={stepIndex} />}
        {hasDispatchButton && <DispatchButton stepIndex={stepIndex} />}
        <StepCard orientation={orientation}>
          <Left orientation={orientation}>
            {content || (
              <StepContent
                dangerouslySetInnerHTML={{__html: instructionHtml}}
                isCompact={false}
                isResponsive={true}
                isScrollable={true}
                footer={footer}
              />
            )}
            {!isCheck && (
              <Toolbar
                getToolbarButtonStyle={getToolbarButtonStyle}
                hintContent={hintContent}
                imageSizes={hintImageSizes}
                isCheck={isCheck}
                onToggle={onToggleHint}
                selectedType={selectedHintType}
                shouldAllToolbarItemsBeEnabled={shouldAllToolbarItemsBeEnabled}
                shouldShowSpinnerWhileLoading={shouldShowSpinnerWhileLoading}
                notes={notes}
                noteContentKey={noteContentKey}
              />
            )}
          </Left>
          <Right orientation={orientation}>
            {media || (
              <StepMedia
                autoplayVideo={autoplayVideo}
                mediaUrl={imageUrl}
                imageSizes={imageSizes}
                metadata={metadata}
                shouldShowSpinnerWhileLoading={shouldShowSpinnerWhileLoading}
              />
            )}
          </Right>
        </StepCard>
        <StepNumber number={number} />
      </StepSlide>
    );
  }
}

export default injectIntl(StepCardComponent);
